import "./styles.less";
import { Button, Row, Col, Typography } from "antd";
import { ImagenOptimizada } from "shared-components/Components/Image/_new_web";
import { useTheme } from "shared-components/Styles/ThemeHook";
import { PageLayout } from "src/Components/Layout/web"
import Link from "next/link";
import { useRouter } from "next/router";
import { ReloadOutlined, ArrowLeftOutlined } from "@ant-design/icons";
import { useUserBox } from "shared-components/ViewFragments/Header/UserBox/hook";

const { Title, Text } = Typography;

export const PropertyEmptyState = ({ data }) => {
	const { theme } = useTheme();
	const {  isLoggedIn,ov_path,user,country_code } = useUserBox();
	
	const ROLE_MAP = {
		BROKER: "inmobiliarias", // => inmobiliarias/administrar-inmuebles
		BUILDER: "constructoras", // => constructoras/administrar-inmuebles
		PRIVATE: "privados", // => privados/administrar-inmuebles
	};

	const text = country_code == 'CO' ? "Puedes volver a intentarlo pronto." : "Podés volver a intentarlo pronto.";
	const userType = ROLE_MAP[user?.data?.me?.role] || (country_code == 'CO' ? "privados" : "inmobiliarias");
	const adminUrl = `${ov_path}${userType}/administrar-inmuebles`;
	
	const router = useRouter();
	return (
		<PageLayout classContainer="error-page" withFooter={false}>
			<Row gutter={[0, 2 * theme.spacing.xxlSpacing]}>
				<Col span={24}>
					<div className="container">
						<div className="logo">
							<ImagenOptimizada
								src={theme.images.favicon}
								alt="Logo"
								className="logo_image"
								width={140}
								height={50}
							/>
						</div>
						<br />

						<Title level={2}>
							{isLoggedIn && data?.owner?.id == user?.data?.me?.id ?  "Tu inmueble aún" : "El inmueble aún"}
							<br></br>
							<span className="text-color">
								{"se esta publicando"}
							</span>
						</Title>

						<Text className="text-center" style={{ marginBottom : 16, fontSize: 14 }}>
							<span>{"Estará listo en unos minutos."}</span> <br></br>
							<span >{text}</span> 
						</Text>

						<div className="empty-state-buttons-conteiner">
							<div className="empty-state-buttons">
								{isLoggedIn  && data?.owner?.id == user?.data?.me?.id ? <Link href={adminUrl}>
									<Button className="btn-secondary empty-state-secondary" icon={<ArrowLeftOutlined />}> {"Administrar inmuebles"} </Button>
								</Link> : ''}
								<Button type="primary" icon={<ReloadOutlined  />} onClick={() => router.replace(router.asPath)}> {"Volver a intentar"} </Button>
							</div>
						</div>
					</div>
				</Col>
			</Row>
		</PageLayout>
	);
};